export const priceTable = [
  {
    max: 9,
    price: 12,
  },
  {
    max: 24,
    price: 11.4,
  },
  {
    max: -1,
    price: 10.8,
  },
];

export const getPriceByAmount = (amount) => {
  const pricePerUnit = priceTable.find((a) => amount < a.max);
  let result = null;
  if (pricePerUnit == null)
    result = amount * priceTable[priceTable.length - 1].price;
  else result = amount * pricePerUnit.price;
  return Math.round(result);
};
